import React, { useState } from "react";
import { Row, Col, Button, Input } from "reactstrap";
import CartItem from "./CartItem";
import { RiArrowRightDoubleLine } from "react-icons/ri";
import RecentlyViewed from "./RecentlyViewed";
import tshirt from "../../../assets/images/dummyImages/t-shirt-1.jpg";
import { useNavigate } from "react-router-dom";
import BackButton from "../../../components/common/BackButton/BackButton";
import styles from './Cart.module.scss';

const Cart = () => {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      itemName: "Sports T-shirt for Men",
      price: 33.99,
      quantity: 1,
      size: "Pink/S/Polyester",
      storeName: "AS Store",
      image: "https://placehold.co/122x128?text=Maelano",
    },
    {
      id: 2,
      itemName: "Stylish T-shirt",
      price: 19.99,
      quantity: 1,
      size: "Blue/M/Cotton",
      storeName: "AS Store",
      image: "https://placehold.co/122x128?text=Maelano",
    },
  ]);

  const handleAddQuantity = (id) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  const handleSubtractQuantity = (id) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id && item.quantity > 1
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  };

  const calculateSubtotal = () =>
    cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);

  const products = [
    {
      id: 1,
      name: "Name of product will be here",
      price: 33.99,
      originalPrice: 49.99,
      rating: 5.0,
      reviews: 300,
      image: tshirt,
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    },
    {
      id: 2,
      name: "Another product name",
      price: 29.99,
      originalPrice: 39.99,
      rating: 4.5,
      reviews: 250,
      image: tshirt,
      description: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.",
    },
    {
      id: 3,
      name: "Stylish T-shirt",
      price: 19.99,
      originalPrice: 24.99,
      rating: 4.2,
      reviews: 180,
      image: tshirt,
      description: "A stylish t-shirt that fits perfectly for all occasions, available in multiple colors.",
    },
    {
      id: 4,
      name: "Cool Hoodie",
      price: 49.99,
      originalPrice: 59.99,
      rating: 4.7,
      reviews: 120,
      image: tshirt,
      description: "Stay warm and stylish with this cool hoodie, made from high-quality fabric.",
    },
    {
      id: 5,
      name: "Casual Sneakers",
      price: 59.99,
      originalPrice: 79.99,
      rating: 4.9,
      reviews: 400,
      image: tshirt,
      description: "Comfortable and trendy sneakers, perfect for everyday use and sports activities.",
    },
    {
      id: 6,
      name: "Name of product will be here",
      price: 33.99,
      originalPrice: 49.99,
      rating: 5.0,
      reviews: 300,
      image: tshirt,
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.",
    },
    {
      id: 7,
      name: "Another product name",
      price: 29.99,
      originalPrice: 39.99,
      rating: 4.5,
      reviews: 250,
      image: tshirt,
      description: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.",
    },
    {
      id: 8,
      name: "Stylish T-shirt",
      price: 19.99,
      originalPrice: 24.99,
      rating: 4.2,
      reviews: 180,
      image: tshirt,
      description: "A stylish t-shirt that fits perfectly for all occasions, available in multiple colors.",
    },
    {
      id: 9,
      name: "Cool Hoodie",
      price: 49.99,
      originalPrice: 59.99,
      rating: 4.7,
      reviews: 120,
      image: tshirt,
      description: "Stay warm and stylish with this cool hoodie, made from high-quality fabric.",
    },
    {
      id: 10,
      name: "Casual Sneakers",
      price: 59.99,
      originalPrice: 79.99,
      rating: 4.9,
      reviews: 400,
      image: tshirt,
      description: "Comfortable and trendy sneakers, perfect for everyday use and sports activities.",
    },
  ];

  return (
    <>
      <BackButton />
      <div className={styles.mainContainer}>
        <h3 className={styles.mainHeading}>Cart Items</h3>

        <Row noGutters className={styles.cartDetailsRow}>
          <Col lg={8}>
            <div className={styles.cartItemsWrapper}>
              {cartItems.map((item) => (
                <CartItem
                  key={item.id}
                  {...item}
                  onAdd={() => handleAddQuantity(item.id)}
                  onSubtract={() => handleSubtractQuantity(item.id)}
                />
              ))}
            </div>
          </Col>

          <Col lg={4}>
            <Row noGutters>
              <Col>
                <div className={styles.totalAmountContainer}>
                  <div className={styles.promotionSection}>
                    <Input type="text" placeholder="Applied Promotion" />
                    <Row noGutters className="pt-2">
                      <Col className="pe-sm-3">
                        <Input type="text" placeholder="Coupon/Voucher Code" />
                      </Col>
                      <Col sm="auto" className="mt-2 m-sm-0 d-flex justify-content-end">
                        <Button color="warning">Apply</Button>
                      </Col>
                    </Row>
                  </div>
                  <div className={styles.totalContainer}>
                    <div className={styles.amountWrapper}>
                      <span>Subtotal:</span>
                      <span>${calculateSubtotal().toFixed(2)}</span>
                    </div>
                    <div className={styles.amountWrapper}>
                      <span>Delivery charges:</span>
                      <span>$00.00</span>
                    </div>
                    <div className={styles.amountWrapper}>
                      <span>Discount:</span>
                      <span>$00.00</span>
                    </div>
                    <div className={styles.total}>
                      <div>Total:</div>
                      <div className={styles.finalTotal}>
                        ${calculateSubtotal().toFixed(2)}
                      </div>
                    </div>
                    <div className={styles.vatText}>
                      VAT Applicable where applicable
                    </div>
                  </div>
                </div>
                <div className={styles.btnContainer}>
                  <Button
                    color="info"
                    className={styles.checkoutBtn}
                    onClick={() => navigate("/cart/checkout")}
                  >
                    Proceed to Checkout
                    <RiArrowRightDoubleLine size={30} className={styles.arrowIcon} />
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <h3 className={styles.sectionHeading}>Recently Viewed</h3>
        <div>
          <RecentlyViewed products={products.slice(0, 6)} />
        </div>

        <h3 className={styles.sectionHeading}>You May Like to Add</h3>
        <div>
          <RecentlyViewed products={products.slice(0, 6)} />
        </div>

      </div>
    </>
  )
}

export default Cart;